import { useLocation } from "react-router-dom";
import classes from "./route-transition.module.scss";

// Forces a remount whenever the path changes (via `key`), which
// retriggers the CSS `animation` below — a lightweight way to get a
// route-change transition without pulling in a new animation library
// just for this. Kept intentionally subtle: this plays on every
// navigation in the app, so anything more dramatic would get tiring
// fast on repeat use.
const RouteTransition = ({ children }) => {
  const location = useLocation();
  return (
    <div key={location.pathname} className={classes["route-transition"]}>
      {children}
    </div>
  );
};

export default RouteTransition;